var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-setting has-bc biz-home-default"},[_c('div',{staticClass:"tool-bar-mask"}),_vm._v(" "),_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title)+_vm._s(_vm.isAllGroup || _vm.isBizVerified != 'NORMAL'?'':' - '+_vm.userGroupName))])]),_vm._v(" "),_c('home-default-comp')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b24252","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bussiness/personalHome/home/homeDefault.vue
// module id = null
// module chunks = 